module.exports = __webpack_public_path__ + "img/P150T_weapon_55.3a2007e2.png";